import React from 'react';

import './Loader.css';

const Loader = () => {
  return <div className={'Loader'}></div>;
};

export default Loader;
